import { createTextFilterContext } from "@/components/TextFilter/createTextFilterContext";

export const planningTextFilter = createTextFilterContext();

export const usePatientOrActivityTitleFilter = planningTextFilter.useFilter;
export const usePatientOrActivityTitleFilterActions =
  planningTextFilter.useFilterActions;
export const usePlanningFilterBannerItem =
  planningTextFilter.useFilterBannerItem;
